import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GroundingChunk } from 'src/app/types/genai';

export type GroundingType = 'google-search' | 'web-search';

export interface CitationData {
  index: number;
  title?: string;
  description?: string;
  source: string;
  groundingType?: GroundingType;
  publishedDate?: string;
}

@Component({
  selector: 'citation-snippet',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './citation-snippet.component.html',
  styleUrl: './citation-snippet.component.scss',
})
export class CitationSnippetComponent {
  @Input() index!: number;
  @Input() title?: string;
  @Input() description?: string;
  @Input() source!: string;
  @Input() groundingType: GroundingType = 'google-search';
  @Input() publishedDate?: string;
  @Input() sidebarMode = false;

  isExpanded = false;

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  get poweredByText(): string {
    switch (this.groundingType) {
      case 'google-search':
        return 'Powered by Google Search';
      case 'web-search':
        return 'Powered by Web Search';
      default:
        return 'Powered by Google Search';
    }
  }

  get hasFullContent(): boolean {
    return !!this.title && !!this.description;
  }

  get hasPartialContent(): boolean {
    return !this.title && !!this.description;
  }

  get hasMinimalContent(): boolean {
    return !this.title && !this.description;
  }

  /**
   * Factory method to create CitationData from GroundingChunk
   */
  static fromGroundingChunk(
    chunk: GroundingChunk,
    index: number,
  ): CitationData {
    return {
      index,
      title: chunk.title || undefined,
      description: chunk.text || undefined,
      source: chunk.uri,
      groundingType: 'web-search',
    };
  }
}
